<template>
    <v-card >
      <v-container v-if="sumfurush_card">
        <v-card-title class="pa-0 mb-2">Наш долг перед поставщиком
          <v-divider class="mx-2" inset vertical></v-divider>
          <export-excel
          :data="filteredFirmaho"
          :worksheet="'Наш долг перед поставщиками '"
          :name="'Отчёт о поставщикам'"
          :title="'Отчёт о поставщикам'"
          :fields="json_fields"
          :auto-width="true"
          :footer="'Итого сумма ' + Number( sumDolg('karz')).toFixed(2)"
          >
          <v-icon  color="success" >
              mdi-microsoft-excel
              </v-icon>
      </export-excel>


        </v-card-title>
        <v-row class="mb-2">
          <v-col cols="12" md="3">



            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Поставщики"
            hide-details
            multiple
            solo
            prepend-icon="mdi-filter-menu-outline"
            :items="firmaho"
            item-text="nom"
            item-value="nom"
            class="m-4"
            @click:clear="get_karz"
            v-model="filters.nom" />


          </v-col>

          <v-col cols="12" md="3">




            <v-autocomplete class="m-4"
            clearable
             item-color="primary"
             color="primary"
             hide-no-data
             hide-details
             multiple
             solo
             prepend-icon="mdi-filter-menu-outline"
             :items="valutaho"
             item-text="valuta"
             item-value="valuta"
             label="Валюта"
             @click:clear="get_karz"
             v-model="filters.valuta" />
          </v-col>
          <v-col cols="12" md="4">

              <v-text-field
              class="m-4"
              color="primary"
              prepend-inner-icon="mdi-magnify"
              solo
              v-model="search"
              label="Поиск"/>

          </v-col>

        </v-row>

        <v-data-table
        :headers="headers"
        :items="filteredFirmaho"
        item-key="id_firma"
        class="elevation-1"
        @dblclick:row="dblclick_firma"
        :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
        :search="search">




          <template slot="body.append">
              <tr>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title ">{{Number( sumDolg('karz')).toFixed(2) }}</th>
                  <th class="title "></th>


              </tr>
          </template>

        </v-data-table>
      </v-container>

      <v-container v-if="furush_card">

        <v-card-title>



            <v-icon @click="back_to_sumfurush" color="primary">
                mdi-arrow-left
            </v-icon>
            <v-divider class="mx-4" inset vertical></v-divider>
            <h4 class="headline mb-0">{{firma_info.nom}}</h4>
            <v-divider class="mx-4" inset vertical></v-divider>

            <export-excel
            :data="filteredVipiska"
            :worksheet="firma_info.nom"
            :name="firma_info.nom"
            :title="firma_info.nom + ' - c ' + date1 + ' до ' + date2"
            :fields="json_fields1"
            :footer="'Остаток долг: ' + karz_firma"
            :auto-width="true"
            >
            <v-icon  color="success" >
                mdi-microsoft-excel
                </v-icon>
            </export-excel>


        </v-card-title>
          <v-row>
          <v-col cols="4">

                <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="date1"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date1"
                    label="Дата 1"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    solo
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date1"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu1 = false"
                  >
                    Отмена
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="get_vipiska"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>

              <v-col cols="4">

                    <v-menu

                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="date2"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date2"
                        label="Дата 2"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        solo
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date2"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu2 = false"
                      >
                        Отмена
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="get_vipiska"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                  <v-col cols="4">

                  <v-autocomplete
                  clearable
                   item-color="primary"
                   color="primary"
                   hide-no-data
                   hide-details
                   multiple
                   solo
                   prepend-icon="mdi-filter-menu-outline"
                   :items="oprs"
                   item-text="opr"
                   item-value="opr"
                   label="Вид операции"
                   @click:clear="get_karz"
                   v-model="filters.opr" />
                </v-col>

                </v-row>


        <v-row class="mb-2">


                <v-col cols="4" md="4" >
                    <strong class="m-2">Остаток на начало {{ ost_na_nachalo }}</strong> <br>
                    <strong class="m-2">Сумма покупки {{ Number( summa_pokupka  + ost_dolga).toFixed(2)}}</strong><br>
                    <strong class="m-2">Сумма скидки {{ summa_skidka }}</strong>
                </v-col>
                <v-col cols="4" md="4" >
                    <strong class="m-2">Сумма оплаты {{ summa_oplata }}</strong><br>
                    <strong class="m-2">Сумма возврата {{ summa_vozvrat }}</strong><br>
                    <strong class="m-2">Остаток долга {{ karz_firma }}</strong>
                </v-col>



                </v-row>





                <v-data-table
                :headers="header_vipiska"
                :items="filteredVipiska"
                @dblclick:row="open_vipiska_info"
                :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
                class="elevation-1">

                <!-- if ITEM==1 then color of row green -->
                <template v-slot:item.opr="{ item }">
                    <strong v-if="item.debit>item.kredit" style="color:red">{{ item.opr }}</strong>
                    <strong v-if="item.debit<item.kredit" style="color:green">{{ item.opr }}</strong>
                    <strong v-if="item.debit==item.kredit" >{{ item.opr }}</strong>
                </template>

                <template v-slot:item.debit="{ item }">
                    <strong v-if="item.debit>0" style="color:red">{{ item.debit }}</strong>
                    <strong v-else>{{ item.debit }}</strong>
                </template>

                <template v-slot:item.kredit="{ item }">
                    <strong v-if="item.kredit>0" style="color:green">{{ item.kredit }}</strong>
                    <strong v-else>{{ item.kredit }}</strong>
                </template>





                  <template slot="body.append">
                      <tr>
                          <th class="title "></th>
                          <th class="title ">{{Number( sumVipiska('debit')).toFixed(2) }}</th>
                          <th class="title ">{{Number( sumVipiska('kredit')).toFixed(2) }}</th>
                          <th class="title "></th>


                      </tr>
                  </template>

                </v-data-table>





      </v-container>


      <v-dialog
      v-model="pokupka_dialog"
      max-width="1100"
    >
      <v-card>
        <v-card-title class="text-h5">
          Покупка № {{ id }}
        </v-card-title>

        <v-card-text>
            <v-data-table
            :headers="header_kharid"
            :items="kharid"
            :search="search"
            :loading="loading"
            loading-text="Загрузка. Пожалуйста подождите"
            :footer-props="{
                'items-per-page-options': [  20, 50, 100],
                'items-per-page-text':'Строк на странице',
            }"
            no-data-text="Данные отсутствуют в таблице"
          >

        </v-data-table>
        </v-card-text>


      </v-card>
    </v-dialog>

    <v-dialog
      v-model="vozvrat_dialog"
      max-width="1100"
      @click:outside="close_dialog_vp"
    >
      <v-card>
        <v-card-title class="text-h5">
          Возврат № {{ id }}
        </v-card-title>

        <v-card-text>
            <v-data-table
            :headers="header_vozvrat"
            :items="vozvrat"
            :search="search"
            :loading="loading"
            loading-text="Загрузка. Пожалуйста подождите"
            :footer-props="{
                'items-per-page-options': [  20, 50, 100],
                'items-per-page-text':'Строк на странице',
            }"
            no-data-text="Данные отсутствуют в таблице"
          >

        </v-data-table>
        </v-card-text>


      </v-card>
    </v-dialog>



      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>


    </v-card>



</template>

<script>
export default {

data: () => ({

  searching: "",
  search: "",

    pokupka_dialog: false,
    vozvrat_dialog: false,

  valutaho: [
    { valuta: "TJS", id_kurb: 1 },
    { valuta: "USD", id_kurb: 2 },
    { valuta: "RUB", id_kurb: 3 },
    ],

  oprs: [
    {opr: "Остаток на начало"},
    {opr: "Покупка товара"},
    {opr: "Оплата долга"},
    {opr: "Долг до программы"},
    {opr: "Возврат товара"},

  ],

      date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,


firma_info:{},

filters: {
    fio: "",
    nom: "",
    valuta: "",
    firma: "",
    comment: "",
    opr:"",
},

karzdoron: [],

headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id_firma',
        },
        { text: 'Поставщик', value: 'nom' },
        { text: 'Валюта', value: 'valuta' },
        { text: 'Долг', value: 'karz' },
        { text: 'Телефон', value: 'tel' },

],

    json_fields: {

    'ID': 'id_firma',
    'Поставщик': 'nom' ,
    'Валюта': 'valuta' ,
    'Долг': 'karz' ,
    'Телефон': 'tel' ,


    },

    header_vipiska:[
        {text: 'Операция', value: 'opr', align: 'start',},
        {text: 'Дебит', value: 'debit'},
        {text: 'Кредит', value: 'kredit'},
        {text: 'Дата', value: 'SANA'},
],

json_fields1: {

'Операция': 'opr',
'Дебит': 'debit' ,
'Кредит': 'kredit' ,
'Дата': 'SANA' ,


},

header_vozvrat:[
    { text: "Код", value: "kod" },
    { text: "Наименование", value: "nom_mol" },
    { text: "Кол-во", value: "mikdor" },
    { text: "Цена", value: "narkh" },
    { text: "Сумма", value: "summa" },
    { text: "Пользователь", value: "nom_user" },
    { text: "Дата", value: "sana" },
    { text: "Комментарий", value: "comment"},
],

snack: false,
    snackColor: '',
    snackText: '',

loading: false,

furush_card: false,
sumfurush_card: true,
firmaho: [],
vipiska:[],
id_firma:0,

ost_na_nachalo:0,
summa_pokupka:0,
summa_skidka:0,
summa_oplata:0,
summa_vozvrat:0,
ost_dolga:0,
karz_firma:0,
kharid:[],
vozvrat:[],
id:0,
header_kharid: [
          {
            text: 'Код',
            align: 'start',
            value: 'kod',
          },
          { text: 'Наименование', value: 'nom' },
          { text: 'Кол-во', value: 'mikdor' },
          { text: 'Закуп.Цена', value: 'narkhi_o' },
          { text: 'Скидка', value: 'skidka' },
          { text: 'Себестоимость', value: 'narkhi_a' },
          { text: 'Маржа', value: 'marja' },
          { text: 'Цена Прод', value: 'narkhi_f' },
          { text: 'Цена опт', value: 'narkhi_opt' },
          { text: 'Сумма', value: 'summa' },
          { text: 'id_mol', value: 'id_mol',  align: ' d-none' },
          { text: 'kod', value: 'kod',  align: ' d-none' },
          { text: 'Годен до', value: 'muhlati_istifoda' },



        ],



}),

mounted(){


  this.get_firmaho();
  this.get_karz();
},

methods: {

    get_firmaho(){
          this.loading = true;
        axios.get('/api/get_firmaho1',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.firmaho = response.data.firmaho;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения фирмы"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },
  sumDolg(key) {
  return  this.filteredFirmaho.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },
  sumVipiska(key) {
  return  this.filteredVipiska.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },

  get_karz(){
    this.loading = true;

    this.karzdoron = [];

    axios.get('/api/dolgi_firmaho_0',
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                    this.karzdoron = response.data.dolgi
                                    this.loading = false;
                                setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.snack = true
                                    this.snackColor = 'error'
                                    this.snackText = "Не удалось получить данные"
                                    this.karzdoron = [];
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }
                            })
                            .catch(error => {
                                this.karzdoron = [];
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = error.response.data.message;
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                            });
  },


  dblclick_firma(event, {item}){
      this.firma_info = item;
      this.sumfurush_card = false
      this.furush_card = true;
      this.id_firma = item.id_firma;
      this.karz_firma = item.karz
      this.get_vipiska()

  },

  open_vipiska_info(event, {item}){
    if(item.ITEM==1){
        this.get_pokupka(item.ID)
        this.id = item.ID
    }else if(item.ITEM==5){
        this.get_vozvrat(item.ID)
        this.id = item.ID
    }
  },

  back_to_sumfurush(){
      this.furush_card = false;
      this.sumfurush_card = true;
  },

  get_vipiska(){


            try{
                this.$refs.menu1.save(this.date1)
                this.$refs.menu2.save(this.date2)
            }catch(e){
               // console.log(e)
            }




            axios.post('/api/get_vipiska/'+this.id_firma, {start: this.date1, end:this.date2},
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                    this.vipiska = response.data.vipiska
                                    this.ost_na_nachalo = response.data.ost_na_nachalo
                                    this.summa_pokupka = response.data.summa_pokupka
                                    this.summa_skidka = response.data.summa_skidka
                                    this.summa_oplata = response.data.summa_oplata
                                    this.summa_vozvrat = response.data.summa_vozvrat
                                    this.ost_dolga = response.data.ost_dolga

                                    this.loading = false;
                                setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.snack = true
                                    this.snackColor = 'error'
                                    this.snackText = "Не удалось получить данные"
                                    this.karzdoron = [];
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }
                            })
                            .catch(error => {
                                this.karzdoron = [];
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = error.response.data.message;
                                console.log(error.response.data.message)
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                            });

  },

  get_pokupka(id){
    this.pokupka_dialog = true;
    this.vozvrat_dialog = false;

    this.loading = true;
                axios.get('/api/show_kharid_of_nakladnoy/'+(id),  {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                        this.loading = false;

                             this.kharid = response.data.kharid;

                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Не удалось получить данные"
                            this.kharid =[];

                            setTimeout(() => {
                                this.error = false;
                            }, 2000);

                        }

                    })
                    .catch(error => {
                        this.loading = false;
                       this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                        this.kharid =[];
                            setTimeout(() => {
                                this.error = false;
                            }, 2000);
                    });
  },

  get_vozvrat(id){
    this.vozvrat_dialog = true;
    this.pokupka_dialog = false;

    this.loading = true;
                axios.get('/api/get_vozvrat1/'+(id),  {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                        this.loading = false;
                             this.vozvrat = response.data.vozvrat;


                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Не удалось получить данные"
                            this.kharid =[];

                            setTimeout(() => {
                                this.error = false;
                            }, 2000);

                        }

                    })
                    .catch(error => {
                        this.loading = false;
                       this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                        this.kharid =[];
                            setTimeout(() => {
                                this.error = false;
                            }, 2000);
                    });
  },

  close_dialog_vp(){
    this.pokupka_dialog = false;
    this.vozvrat_dialog = false;
    this.kharid = [];
    this.vozvrat = [];
  }


},

computed: {

    filteredFirmaho() {
  let filter = this.karzdoron.filter((id_firma) => {
  for (const [key, filterValue] of Object.entries(this.filters)) {
    // if (!filterValue.length) continue;
    if (!filterValue.length && typeof filterValue !== "boolean") continue; // No filters selected -> show all products.
    if (typeof filterValue === "boolean" && !filterValue) continue; // exclude the checkbox value if not true/false

    let dropdownValue = id_firma[key];

    //If its an array
    if (typeof filterValue === "object") {
      //Single value (single dropdown value)
      if (typeof dropdownValue === "string") {
        if (
          filterValue.findIndex((val) => {
            return val === dropdownValue.trim();
          }) === -1
        )
          return false;
        //Multiple values (multiple dropdown values)
      } else if (typeof dropdownValue === "object") {
        for (const filterString of filterValue) {
          if (dropdownValue.indexOf(filterString) === -1) return false;
        }
      }

      //If its a boolean
    } else if (typeof filterValue === "boolean") {
      if (typeof dropdownValue === "string") {
        if (dropdownValue.length == 0 && filterValue) return false;
        if (dropdownValue.length > 0 && !filterValue) return false;
      } else if (filterValue != dropdownValue) return false;

      //If its a string
    } else if (typeof filterValue === "string") {
      if (typeof filterValue === "string") {
        if (!dropdownValue || dropdownValue.indexOf(filterValue) === -1)
          return false;
      }
    }
  }
  return true;
});
return filter;

},

filteredVipiska() {
  let filter = this.vipiska.filter((FIRMA) => {
  for (const [key, filterValue] of Object.entries(this.filters)) {
    // if (!filterValue.length) continue;
    if (!filterValue.length && typeof filterValue !== "boolean") continue; // No filters selected -> show all products.
    if (typeof filterValue === "boolean" && !filterValue) continue; // exclude the checkbox value if not true/false

    let dropdownValue = FIRMA[key];

    //If its an array
    if (typeof filterValue === "object") {
      //Single value (single dropdown value)
      if (typeof dropdownValue === "string") {
        if (
          filterValue.findIndex((val) => {
            return val === dropdownValue.trim();
          }) === -1
        )
          return false;
        //Multiple values (multiple dropdown values)
      } else if (typeof dropdownValue === "object") {
        for (const filterString of filterValue) {
          if (dropdownValue.indexOf(filterString) === -1) return false;
        }
      }

      //If its a boolean
    } else if (typeof filterValue === "boolean") {
      if (typeof dropdownValue === "string") {
        if (dropdownValue.length == 0 && filterValue) return false;
        if (dropdownValue.length > 0 && !filterValue) return false;
      } else if (filterValue != dropdownValue) return false;

      //If its a string
    } else if (typeof filterValue === "string") {
      if (typeof filterValue === "string") {
        if (!dropdownValue || dropdownValue.indexOf(filterValue) === -1)
          return false;
      }
    }
  }
  return true;
});
return filter;

},


}

}
</script>

<style  scoped>

</style>



